import NumberFormat from 'react-number-format';

const DecimalFormatCustom = (props: any) => {
  const {
    inputRef, onChange, ...other
  } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange?.({
          target: {
            value: values.value
          }
        });
      }}
      decimalScale={2}
      thousandSeparator
      isNumericString
    />
  );
};


export default DecimalFormatCustom;
